import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['element']

  toggle(event) {
    const selectedValue = event.currentTarget.value

    this.elementTargets.forEach(el => {
      const isSelected = selectedValue === el.getAttribute('data-key')

      if (isSelected) {
        el.classList.remove('hidden-important')
      } else {
        el.classList.add('hidden-important')
      }

      this.toggleRequiredFields(el, isSelected)
    })
  }

  toggleRequiredFields(element, enabled) {
    const requiredFields = element.querySelectorAll('[data-conditional-required="true"]')

    requiredFields.forEach(field => {
      field.required = enabled

      if (!enabled) {
        field.removeAttribute('required')
      }
    })
  }
}
